import { Pipe, PipeTransform } from '@angular/core';
import { Project } from '@shared/index';

@Pipe({
  name: 'projectName'
})
export class ProjectNamePipe implements PipeTransform {

  public transform(value?: Project): unknown {
    if (!value) return "Not found.";
    if (value._id == "-") return $localize`:@@my-bots:Meine Bots`;
    return value.name;
  }

}